// pages/User_OfficerDetailDuty.jsx or components/User_OfficerDetailDuty.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useGuardStore } from "../context/GuardContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function User_OfficerDetailDuty() {
  const navigate = useNavigate();
  const { guardId } = useParams();
  const { selectedGuard } = useGuardStore();

  const finalGuardId = guardId || selectedGuard?.id;

  const [vip, setVip] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!finalGuardId) {
      navigate("/guardlist");
      return;
    }

    async function fetchVip() {
      try {
        const role = localStorage.getItem("role");
        const token = localStorage.getItem(`${role}Token`);

        if (!token) {
          console.error("Token missing for role:", role);
          setVip(null);
          return;
        }

        const res = await axios.get(
          `${BASE_URL}/api/assignments/getvip/${finalGuardId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const extracted = res.data?.data || res.data?.vip || res.data || null;
        setVip(extracted);
      } catch (error) {
        console.error("VIP Fetch Error:", error);
        setVip(null);
      } finally {
        setLoading(false);
      }
    }

    fetchVip();
  }, [finalGuardId, navigate]);

  if (loading) {
    return (
      <div className="loading-wrapper">
        <div className="spinner">
          <i className="fas fa-spinner fa-spin"></i>
        </div>
        <p>Loading Shift Details...</p>
      </div>
    );
  }

  if (!vip) {
    return (
      <div className="empty-state">
        <i className="fas fa-exclamation-triangle fa-3x"></i>
        <h3>No VIP Assignment Found</h3>
        <p>This officer currently has no assigned VIP or duty.</p>
        <button onClick={() => navigate("/guardlist")} className="back-btn">
          <i className="fas fa-arrow-left"></i> Back to Officer List
        </button>
      </div>
    );
  }

  return (
    <div className="duty-wrapper">
      {/* Header */}
      <header className="duty-header">
        <div className="header-content">
          <h1>
            <i className="fas fa-shield-alt"></i> Officer Shift Details
          </h1>
          <p>Assigned VIP & Duty Schedule Overview</p>
        </div>
      </header>

      {/* Main Card */}
      <main className="duty-main">
        <div className="duty-card">
          <div className="vip-profile">
            <div className="vip-avatar">
              <i className="fas fa-user-tie"></i>
            </div>
            <div className="vip-info">
              <h2>{vip.name || "N/A"}</h2>
              <p className="designation">{vip.designation || "N/A"}</p>
            </div>
          </div>

          <div className="details-grid">
            {[
              { icon: "fa-id-badge", label: "Assignment ID", value: vip.id },
              { icon: "fa-user", label: "VIP Name", value: vip.name },
              { icon: "fa-briefcase", label: "Designation", value: vip.designation },
              { icon: "fa-clock", label: "Start Time", value: vip.startAt || "N/A" },
              { icon: "fa-clock", label: "End Time", value: vip.endAt || "N/A" },
              { icon: "fa-tasks", label: "Status", value: vip.status || "Assigned" },
            ].map((item, i) => (
              <div key={i} className="detail-item">
                <div className="detail-icon">
                  <i className={`fas ${item.icon}`}></i>
                </div>
                <div className="detail-content">
                  <span className="label">{item.label}</span>
                  <span className="value">{item.value}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="action-buttons">
            <button onClick={() => navigate(-1)} className="back-btn">
              <i className="fas fa-arrow-left"></i> Go Back
            </button>
          </div>
        </div>
      </main>

      <style jsx>{`
        .duty-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          color: #e2e8f0;
          padding: 2rem 1rem;
        }

        .duty-header {
          background: rgba(15, 23, 42, 0.95);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(59, 130, 246, 0.2);
          padding: 2rem;
          text-align: center;
          margin-bottom: 2rem;
        }

        .header-content h1 {
          font-size: 2.2rem;
          font-weight: 700;
          color: #60a5fa;
          margin: 0 0 0.8rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
        }

        .header-content p {
          opacity: 0.9;
          font-size: 1.1rem;
          margin: 0;
        }

        .duty-main {
          max-width: 900px;
          margin: 0 auto;
        }

        .duty-card {
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(12px);
          border-radius: 20px;
          padding: 2.5rem;
          border: 1px solid rgba(59, 130, 246, 0.3);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          transition: all 0.3s ease;
        }

        .duty-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 50px rgba(59, 130, 246, 0.15);
        }

        .vip-profile {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          margin-bottom: 2.5rem;
          padding-bottom: 1.5rem;
          border-bottom: 1px solid rgba(100, 116, 139, 0.4);
          flex-direction: row;
        }

        .vip-avatar {
          width: 90px;
          height: 90px;
          background: linear-gradient(135deg, #3b82f6, #2563eb);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.5rem;
          color: white;
          flex-shrink: 0;
        }

        .vip-info h2 {
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0 0 0.5rem;
          color: white;
        }

        .designation {
          font-size: 1.1rem;
          opacity: 0.85;
          color: #60a5fa;
        }

        .details-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2.5rem;
        }

        .detail-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: rgba(15, 23, 42, 0.6);
          border-radius: 14px;
          border: 1px solid rgba(59, 130, 246, 0.2);
          transition: all 0.3s ease;
        }

        .detail-item:hover {
          background: rgba(59, 130, 246, 0.1);
          border-color: #60a5fa;
        }

        .detail-icon {
          width: 50px;
          height: 50px;
          background: #2563eb;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.3rem;
          flex-shrink: 0;
        }

        .detail-content {
          flex: 1;
        }

        .label {
          display: block;
          font-size: 0.9rem;
          opacity: 0.8;
          margin-bottom: 0.3rem;
        }

        .value {
          font-size: 1.1rem;
          font-weight: 600;
          color: #ffffff;
        }

        .action-buttons {
          display: flex;
          justify-content: center;
        }

        .back-btn {
          background: linear-gradient(135deg, #ef4444, #dc2626);
          color: white;
          border: none;
          padding: 0.9rem 2rem;
          border-radius: 14px;
          font-weight: 600;
          font-size: 1.1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.6rem;
          transition: all 0.3s ease;
        }

        .back-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(239, 68, 68, 0.3);
        }

        .loading-wrapper {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #60a5fa;
        }

        .spinner i {
          font-size: 3rem;
          margin-bottom: 1rem;
        }

        .empty-state {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 2rem;
          color: #e2e8f0;
        }

        .empty-state i {
          color: #f59e0b;
          margin-bottom: 1.5rem;
        }

        .empty-state h3 {
          font-size: 1.8rem;
          margin-bottom: 0.8rem;
        }

        .empty-state p {
          opacity: 0.8;
          margin-bottom: 2rem;
          font-size: 1.1rem;
        }

        @media (max-width: 768px) {
          .duty-header {
            padding: 1.5rem;
          }

          .header-content h1 {
            font-size: 1.8rem;
            flex-direction: column;
            gap: 0.5rem;
          }

          .duty-card {
            padding: 2rem 1.5rem;
          }

          .vip-profile {
            flex-direction: column;
            text-align: center;
          }

          .vip-avatar {
            width: 80px;
            height: 80px;
            font-size: 2.2rem;
          }

          .details-grid {
            grid-template-columns: 1fr;
          }

          .detail-item {
            padding: 1rem;
          }
        }

        @media (max-width: 576px) {
          .duty-wrapper {
            padding: 1rem;
          }

          .duty-card {
            padding: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
}

// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { useGuardStore } from "../context/GuardContext";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export default function User_OfficerDetailDuty() {
//   const navigate = useNavigate();
//   const { guardId } = useParams();
//   const { selectedGuard } = useGuardStore();

//   const finalGuardId = guardId || selectedGuard?.id;

//   const [vip, setVip] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (!finalGuardId) {
//       navigate("/guardlist");
//       return;
//     }

//     async function fetchVip() {
//       try {
//         const role = localStorage.getItem("role");
//         const token = localStorage.getItem(`${role}Token`);

//         if (!token) {
//           console.error("❌ Token missing for role:", role);
//           setVip(null);
//           return;
//         }
//         const res = await axios.get(
//           `${BASE_URL}/api/assignments/getvip/${finalGuardId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`, //  TOKEN SENT
//             },
//           }
//         );

//         const extracted = res.data?.data || res.data?.vip || res.data || null;

//         setVip(extracted);
//       } catch (error) {
//         console.error("VIP Fetch Error:", error);
//         setVip(null);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchVip();
//   }, [finalGuardId, navigate]);

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <i className="fa fa-spinner fa-spin fa-2x text-primary mb-3"></i>
//         <h5>Loading Shift...</h5>
//       </div>
//     );
//   }

//   if (!vip) {
//     return (
//       <div style={styles.emptyBox}>
//         <h2>No VIP Assignment Found</h2>
//         <button style={styles.backBtn} onClick={() => navigate("/guardlist")}>
//           Go Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.pageContainer}>
//       <div style={styles.header}>
//         <h2 style={styles.headerTitle}>
//           <i className="fa fa-shield me-2"></i> Officer Shift Details
//         </h2>
//         <p style={styles.headerSubtitle}>
//           Assigned VIP & Duty Schedule Overview
//         </p>
//       </div>

//       <div style={styles.card}>
//         <div style={styles.profileRow}>
//           <div style={styles.leftBox}>
//             <h4 style={styles.name}>{vip.name || "N/A"}</h4>
//             <p style={styles.role}>{vip.designation || "N/A"}</p>
//           </div>

//           <div style={styles.rightBox}>
//             {[
//               ["Officer Assignment ID", vip.id],
//               ["VIP Name", vip.name],
//               ["Designation", vip.designation],
//               ["Start Time", vip.startAt || "N/A"],
//               ["End Time", vip.endAt || "N/A"],
//               ["Status", vip.status || "Assigned"],
//             ].map(([label, value], i) => (
//               <div style={styles.detailRow} key={i}>
//                 <div style={styles.detailLabel}>{label}:</div>
//                 <div style={styles.detailValue}>{value}</div>
//               </div>
//             ))}

//             <div style={{ marginTop: "20px", display: "flex", gap: "12px" }}>
//               <button style={styles.backBtn} onClick={() => navigate(-1)}>
//                 ← Back
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ================== UI STYLES ================== */

// const styles = {
//   pageContainer: {
//     padding: "30px",
//     minHeight: "100vh",
//     background: "linear-gradient(135deg, rgba(145,195,243,0.7), rgba(233,239,125,0.9))",
//     backdropFilter: "blur(6px)",
//   },
//   header: {
//     marginBottom: "25px",
//     padding: "20px",
//     background: "linear-gradient(135deg, #4e54c8, #8f94fb)",
//     borderRadius: "14px",
//     color: "white",
//   },
//   headerTitle: { margin: 0, fontSize: "26px", fontWeight: "700" },
//   headerSubtitle: { marginTop: "5px", opacity: 0.9 },
//   card: {
//    background: "rgba(255,255,255,0.7)",
//     borderRadius: "18px",
//     padding: "31px",
//   },
//   profileRow: { display: "flex", gap: "40px", flexWrap: "wrap" },
//   leftBox: { flex: "1", textAlign: "center" },
//   name: { fontSize: "22px", fontWeight: "700", marginTop: "50px" },
//   role: { fontSize: "15px", color: "#777" },
//   rightBox: { flex: "2" },
//   detailRow: { display: "flex", marginBottom: "12px" },
//   detailLabel: { width: "150px", fontWeight: "600" },
//   detailValue: { flex: 1 },
//   backBtn: {
//     background: "#1e73be",
//     color: "white",
//     padding: "10px 18px",
//     borderRadius: "10px",
//     border: "none",
//     cursor: "pointer",
//   },
//   emptyBox: { padding: "50px", textAlign: "center" },
// };
